'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionTaxesRepository', function ($resource) {
    var self = this;

    var resource = $resource('/api/v1/transactions/:transactionId/taxes', {}, {
      get: { method: 'get', isArray: true }
    });

    self.fetchTaxes = function (activeTransaction) {
      return resource.get({ transactionId: activeTransaction.id }).$promise;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/TransactionTaxesRepository.js
// module id = 628
// module chunks = 0